import { ReactElement } from 'react';

import { ConditionalWrapper } from '@localstack/integrations';

import { EmulatorLayoutProps } from '@localstack/types';

import { DeprecatedBaseHeader, StatusAlert } from '@localstack/ui';

import { InstanceHeaderWrapper } from '../Headers/InstanceHeaderWrapper';

import { LayoutContainer } from '../LayoutContainer';

import { CustomerLayout, CustomerLayoutProps } from './CustomerLayout';

export type InstanceLayoutProps = CustomerLayoutProps & EmulatorLayoutProps;

export const InstanceLayout = ({
  children,
  title,
  planFamily,
  actions,
  maxWidth,
  fullScreen,
  flushContent,
  tabs,
  endpoint,
  ...rest
}: InstanceLayoutProps): ReactElement => {
  const showInstanceHeader = !(fullScreen ?? false);

  return (
    <CustomerLayout {...rest} title={title}>
      <ConditionalWrapper
        condition={showInstanceHeader}
        wrapper={(content) => <InstanceHeaderWrapper>{content}</InstanceHeaderWrapper>}
      >
        <>
          <DeprecatedBaseHeader
            actions={actions}
            title={title}
            planFamily={planFamily}
            maxWidth={maxWidth}
            fullScreen={fullScreen}
            tabs={tabs}
          />
          <LayoutContainer fullScreen={fullScreen} maxWidth={maxWidth} flushContent={flushContent}>
            <StatusAlert endpoint={endpoint} />
            {children}
          </LayoutContainer>
        </>
      </ConditionalWrapper>
    </CustomerLayout>
  );
};
